import { useSyncExternalStore, useRef, useCallback } from 'react';

const emptySubscribe = () => () => {};

export function useClientSnapshot(getRawData, serverFallback) {
  // Store the "stable" version of the object to prevent loops
  const memo = useRef({ stringified: '', value: serverFallback });

  const getSnapshot = useCallback(() => {
    const data = getRawData();

    // 1. Primitives (strings/numbers) are stable by default
    if (typeof data !== 'object' || data === null) {
      return data;
    }

    // 2. Objects/Arrays: Only update the reference if the content changed
    const currentStringified = JSON.stringify(data);
    if (currentStringified !== memo.current.stringified) {
      memo.current = { stringified: currentStringified, value: data };
    }

    return memo.current.value;
  }, [getRawData]);

  return useSyncExternalStore(emptySubscribe, getSnapshot, () => serverFallback);
}
